import * as React from "react";
import { Divider } from "antd";
import { CodeEditor } from "../../../group/identityMatcher/codeEditor";
import { CaretRightOutlined } from "@ant-design/icons";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { formSet, formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";
import { store } from "../../../../store";

interface Props {}
export const AddonByok: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const isEnabled = useCpFormValue(`addons.byok.isEnabled`);
  const config = useCpFormValue(`addons.byok.config`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        <div className={`flex items-baseline`}>
          <div
            className={`flex items-baseline gap-2 color-link-hover cursor-pointer`}
            onClick={() => {
              setIsCollapsed((x) => !x);
            }}
          >
            <CaretRightOutlined rotate={isCollapsed ? 0 : 90} className={`self-center`} />
            <span>Add-On | CPLN Platform</span>
          </div>
        </div>
      </Divider>
      <div id={`addon-byok`} style={{ scrollMarginTop: 200 }}>
        {isCollapsed ? null : (
          <div>
            <CpFormItem>
              <CpLabel name={`addons.byok.location`}>Location</CpLabel>
              <CpKindSelect
                kind="location"
                name={`addons.byok.location`}
                optionValue="name"
                queries={[{ property: "provider", value: "byok" }]}
                style={{ width: 600 }}
              />
              <CpErrorWarning name={`addons.byok.location`} />
            </CpFormItem>
            <CpFormItem>
              <div className="flex items-center gap-2">
                <CpLabel name={`addons.byok.ignoreUpdates`}>Ignore Updates</CpLabel>
                <CpSwitch name={`addons.byok.ignoreUpdates`} />
              </div>
              <CpErrorWarning name={`addons.byok.ignoreUpdates`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name="skip">Config</CpLabel>
              <CodeEditor
                language={`yaml`}
                options={{ basicSetup: { autocompletion: false }, style: { width: "100%", fontSize: 14 } }}
                value={config}
                setValue={(value) => formSetValue(id, `addons.byok.config`, value)}
                onChange={() => {
                  const name = "addons.byok.config";
                  formSet(id, `fieldStates.${name}.modified`, true);

                  const form = store.getState().form.instances[id];
                  const onChangeCounter = form.meta.onChangeCounter;
                  formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
                }}
                onFocus={() => {
                  const name = "addons.byok.config";
                  formSet(id, `fieldStates.${name}.focused`, true);
                  formSet(id, `fieldStates.${name}.visited`, true);
                }}
                onBlur={() => {
                  const name = "addons.byok.config";
                  formSet(id, `fieldStates.${name}.focused`, false);
                  formSet(id, `fieldStates.${name}.touched`, true);

                  const form = store.getState().form.instances[id];
                  const onBlurCounter = form.meta.onBlurCounter;
                  formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
                }}
              />
            </CpFormItem>
          </div>
        )}
      </div>
    </>
  );
};
